export default __webpack_public_path__ + "static/media/bet.a7b9283f.mp3";